const fileTypeMap: { [key: string]: RegExp } = {
  pdf: /\.pdf$/i,
  docx: /\.docx$/i,
  image: /\.(png|jpe?g|gif|webp|bmp|svg)$/i,
};

export const getFileType = (fileName?: string): string => {
  if (!fileName) return 'unknown';
  return Object.entries(fileTypeMap).find(([type, regex]) => regex.test(fileName))?.[0] || 'other';
};
